import { useState, useCallback } from "react";
import constate from "constate";

const useGuideTourContext = (props) => {
  const {
    initialValue = {
      availableInSidebar: {},
    },
  } = props;
  const [sidebarGuidedTour, setSidebarGuidedTour] = useState(initialValue);
  const [
    suppressTeamProfileHeaderScrollCollapse,
    setSuppressTeamProfileHeaderScrollCollapse,
  ] = useState(false);

  const setAvailableInSidebarGuidedTour = useCallback((tourName, available) => {
    setSidebarGuidedTour((value) => {
      const { availableInSidebar } = value;
      return {
        availableInSidebar: { ...availableInSidebar, [tourName]: available },
      };
    });
  }, []);

  return {
    sidebarGuidedTour,
    setAvailableInSidebarGuidedTour,
    suppressTeamProfileHeaderScrollCollapse,
    setSuppressTeamProfileHeaderScrollCollapse,
  };
};

const [
  GuideTourContextProvider,
  useSidebarGuidedTour,
  useSetAvailableInSidebarGuidedTour,
  useSuppressTeamProfileHeaderScrollCollapse,
  useSetSuppressTeamProfileHeaderScrollCollapse,
] = constate(
  useGuideTourContext,
  (value) => value.sidebarGuidedTour,
  (value) => value.setAvailableInSidebarGuidedTour,
  (value) => value.suppressTeamProfileHeaderScrollCollapse,
  (value) => value.setSuppressTeamProfileHeaderScrollCollapse
);

export {
  GuideTourContextProvider,
  useSidebarGuidedTour,
  useSetAvailableInSidebarGuidedTour,
  useSuppressTeamProfileHeaderScrollCollapse,
  useSetSuppressTeamProfileHeaderScrollCollapse,
};
